var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.67709 5.5L9.34611 11.3874M9.34611 11.3874L3.67709 18.5M9.34611 11.3874L10.6354 12.7263C11.4038 13.4435 12.5963 13.4435 13.3647 12.7263L14.72 11.3874M20.5 5.67709L14.72 11.3874M14.72 11.3874L20.5 18.3229M20.5 18.3229C20.8112 17.9703 21 17.5072 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 17.5973 3.26188 18.1335 3.67709 18.5C4.02965 18.8112 4.49278 19 5 19H19C19.5973 19 20.1335 18.7381 20.5 18.3229Z",
    stroke: "#F2F5F8",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailLight);
export default __webpack_public_path__ + "static/media/mail-light.5ea571ea15c5a82693c65c4da7ad37a6.svg";
export { ForwardRef as ReactComponent };